/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1LocationCitiesQueryResponse,
  GetApiV1LocationCities401,
  GetApiV1LocationCities500,
} from "../../types/locationCityController/GetApiV1LocationCities.ts";

function getGetApiV1LocationCitiesUrl() {
  const res = { method: "GET", url: `/api/v1/location/cities` as const };
  return res;
}

/**
 * @description Retorna todas as cidades cadastradas com estado e país, ordenadas por nome. **(Requer Authorization para autenticação)**
 * @summary Listar cidades (Requer Authorization para autenticação)
 * {@link /api/v1/location/cities}
 */
export async function getApiV1LocationCities(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1LocationCitiesQueryResponse,
    ResponseErrorConfig<GetApiV1LocationCities401 | GetApiV1LocationCities500>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1LocationCitiesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
